import { render, staticRenderFns } from "./AddPoint.vue?vue&type=template&id=4824d548&"
import script from "./AddPoint.vue?vue&type=script&lang=js&"
export * from "./AddPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports